import React from "react";
import styled from "styled-components";

import GridItem from "./GridItem";

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-row-gap: 50px;
  justify-content: space-between;
  @media (max-width: 400px) {
    margin: 0px auto;
  }
`;

export default (props) => {
  const { companies, intros } = props;
  return (
    <Grid>
      {companies.map((company, idx) => (
        <GridItem
          key={idx}
          company={company}
          companies={companies}
          intros={intros}
        />
      ))}
    </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/components/Grid/Grid.js